import React from 'react'
import { intervalToDuration } from 'date-fns'
import { getTimezoneOffset } from 'date-fns-tz'

import { IANA_TZ_OPTIONS } from '@makyoapp/makyo-common'
import { User16 } from '@makyoapp/makyo-icon/icon'
import { SelectDropdown, SelectDropdownProps } from '@makyoapp/makyo-ui'

import { NOW, TZ_AUTO } from '@/shared/constants'

export interface TzDdProps extends SelectDropdownProps<string> {
  id: string
  value: string
  onChange: (next: string) => void
  defaultValue?: string
  withAuto?: boolean
}
export function TzDd({ id, value, onChange, defaultValue, withAuto, ...props }: TzDdProps) {
  const opts = withAuto ? ['#{dynamic}#', TZ_AUTO.value, '#div#', '#{fixed}#', ...IANA_TZ_OPTIONS] : IANA_TZ_OPTIONS

  return (
    <SelectDropdown
      id={id}
      withSearch
      value={value}
      onChange={(opt) => {
        onChange(opt)
      }}
      renderOption={(opt) => {
        if (opt === 'auto') {
          return (
            <span className='flex-c'>
              <User16 />
              <span>Local Time Zone</span>
            </span>
          )
        }

        const tzMs = getTimezoneOffset(opt, NOW)
        let fmt
        try {
          fmt = intervalToDuration({
            start: 0,
            end: tzMs,
          })
        } catch (e) {
          //
        }
        const plusOrNeg = tzMs < 0 ? '-' : '+'
        return (
          <div className='w-full min-w-0 flex-c justify-between'>
            <span>{opt}</span>
            <span className='text-light text-m-sm'>
              UTC {plusOrNeg}
              {String(fmt?.hours).padStart(2, '0')}:{String(fmt?.minutes).padStart(2, '0')}
            </span>
          </div>
        )
      }}
      searchFilter={(opt, keyword) => {
        if (opt === 'auto') {
          return opt.includes(keyword.toLowerCase())
        }

        const tzMs = getTimezoneOffset(opt, NOW)
        const plusOrNeg = tzMs < 0 ? '-' : '+'

        let fmt
        try {
          fmt = intervalToDuration({
            start: 0,
            end: tzMs,
          })
        } catch (e) {
          //
        }

        return `${opt}${
          fmt
            ? ` ${plusOrNeg}${String(fmt.hours).padStart(2, '0')}:
                  ${String(fmt.minutes).padStart(2, '0')}`
            : ''
        }`
          .toLowerCase()
          .includes(keyword.toLowerCase())
      }}
      optionLabel={(opt) => opt}
      options={opts}
      {...props}
    />
  )
}
